import { SORT, SEARCH } from 'constants/FilterConstants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import * as types from 'modules/screensaver/actionTypes';
import { getPersistedFilters } from 'services/StateLoader';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {'text' | 'sort' } ScreensaverFilterField */

/** @typedef {Record<ScreensaverFilterField, string | number | Array<string> | Array<number>>} ScreensaverFiltersReducer */

const persistedFilters = getPersistedFilters()?.filters?.screensavers ?? {};

export const emptyState = {
  [SEARCH]: null,
  [SORT]: 'name,ASC',
};

/** @type {FilterAdapter<KiosksFiltersReducer>} */
const filterAdapter = filterSliceAdapter(emptyState, persistedFilters);

export default createReducer(filterAdapter.getInitialState(), {
  [LOCATION_CHANGE]: filterAdapter.resetFilters,
  [types.SET_SCREENSAVERS_DASHBOARD_FILTER]: filterAdapter.setFilter,
  [types.CLEAR_SCREENSAVERS_DASHBOARD_FILTER]: filterAdapter.resetFilters,
});
